import type DefaultError from "@ext/errorHandlers/logic/DefaultError";
import { type CatalogLinkStatus, isCloningStatus, isNotLoadedStatus } from "@ext/navigation/NavigationLinks";

export type CardState = CatalogLinkStatus | "opening" | "clone-error";

interface LiveCardState {
	isCloning: boolean;
	isCloneFinished: boolean;
	error: DefaultError | null;
	isLoading: boolean;
}

export const getCardState = (
	status: CatalogLinkStatus,
	{ isCloning, isCloneFinished, error, isLoading }: LiveCardState,
): CardState => {
	if (error) return "clone-error";
	if (isCloning) return isNotLoadedStatus(status) ? "space-cloning" : "cloning";
	if (isLoading || (isCloneFinished && isCloningStatus(status))) return "opening";
	return status;
};
